import React from 'react'

import { AppsTwitterShopsView } from './AppsTwitterShopsView'
import { useTwitterShops } from './hooks/useTwitterShops'

export const AppsTwitterShopsContainer = () => {
  const { status, productsLink } = useTwitterShops()

  return <AppsTwitterShopsView status={status} productsLink={productsLink} />
}
